import { signOut } from "aws-amplify/auth";
import { useCallback } from "react";

import useAuthStore from "../stores/authStore";

export default function useLogout() {
  return useCallback(() => {
    signOut()
      .then(() => {
        localStorage.removeItem("avatarDataUri");
        useAuthStore.getState().logOut();
        window.location.reload();
      })
      .catch(() => {});
  }, []);
}
